const snackbar = (message, variant, enqueueSnackbar) => {
  enqueueSnackbar(message, {
    variant
  })
}

export default snackbar
